import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { setCurrentNewHireEnrollmentEligibility, setMemberNewHireGhlEnrollments, setNewHireEnrollmentMemeberEmploymentData } from '../../slice/new-hire-enrollment-slices';
import { getGhlForms } from '../../../../../../global/ducks/mlps-api';

export function useMemberGHLEmploymentId() {
	const dispatch = useDispatch();

	const memberCurrentEmploymentIdLoaded = useSelector<TcsmStates, boolean>(state => state?.newHireEnrollmentState?.memberCurrentEmploymentIdLoaded);
	const personGuid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);

    useEffect(() => {
        if (personGuid && !memberCurrentEmploymentIdLoaded) {            
            dispatch(getGhlForms(
                personGuid,                
                (response)=>{                                       
                    dispatch(setMemberNewHireGhlEnrollments(response?.data));
                    if (response?.data[0]) {
                        dispatch(setCurrentNewHireEnrollmentEligibility(!!response?.data[0]?.employment_id));
                        dispatch(setNewHireEnrollmentMemeberEmploymentData(response?.data[0]?.employment_id, response?.data[0]?.employer));
                    }
                })); 
        }
    }, [memberCurrentEmploymentIdLoaded, personGuid]);

	return memberCurrentEmploymentIdLoaded;
}